/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Time_Cps_LabelInputs */

const en_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate timing by characters per second`)
};

const fr_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculer le minutage par caractères par seconde`)
};

const de_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitmessung in Zeichen pro Sekunde berechnen`)
};

const it_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il tempo in caratteri al secondo`)
};

const ru_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рассчитать время в символах в секунду.`)
};

const es_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcular el tiempo por caracteres por segundo`)
};

const zh_cn2_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按每秒字符数计算计时`)
};

const ja_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1秒あたりの文字数でタイミングを計算する`)
};

const hi_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति सेकंड अक्षरों के आधार पर समय की गणना करें`)
};

const pt_pt2_context_menu_auto_time_cps_label = /** @type {(inputs: Context_Menu_Auto_Time_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o tempo por caracteres por segundo.`)
};

/**
* | output |
* | --- |
* | "Calculate timing by characters per second" |
*
* @param {Context_Menu_Auto_Time_Cps_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_time_cps_label = /** @type {((inputs?: Context_Menu_Auto_Time_Cps_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Time_Cps_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_auto_time_cps_label(inputs)
	if (locale === "de") return de_context_menu_auto_time_cps_label(inputs)
	if (locale === "it") return it_context_menu_auto_time_cps_label(inputs)
	if (locale === "ru") return ru_context_menu_auto_time_cps_label(inputs)
	if (locale === "es") return es_context_menu_auto_time_cps_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_auto_time_cps_label(inputs)
	if (locale === "ja") return ja_context_menu_auto_time_cps_label(inputs)
	if (locale === "hi") return hi_context_menu_auto_time_cps_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_auto_time_cps_label(inputs)
	return en_context_menu_auto_time_cps_label(inputs)
});